// Reducer that handles page level data, that is, parent reducer
import pageReducer from './page'

export default pageReducer
